import { ApiPath } from "paths";
import { Post } from "services";

export const getPabblySsoLink = async ({ venueId }) => {
  const res = await Post(`${ApiPath.GET_PABBLY_SSO_LINK(venueId)}`);
  return res;
};
